import { useCallback, useRef } from "react";

export const useThrottle = <Args extends unknown[]>(fn: (...args: Args) => void, delay: number) => {
    const lastCallRef = useRef(0);

    return useCallback(
        (...args: Args) => {
            const now = Date.now();

            if (now - lastCallRef.current < delay) return;

            lastCallRef.current = now;
            fn(...args);
        },
        [fn, delay],
    );
};
